export const theme = {
  colors: {
    bg: '#f4f1ea',
    bgAlt: '#ebe6dc',
    surface: '#fffdf9',
    border: '#d4cfc4',
    text: '#2c2825',
    muted: '#6b6560',
    accent: '#c45c3e',
    accentSoft: '#e8d5cf',
    shadow: 'rgba(44, 40, 37, 0.08)',
    gallery: '#1b1b1b',
  },
  fonts: {
    body: '"BlockCraft", monospace',
    display: '"Arcade Alternate", sans-serif',
  },
  fontSizes: {
    xs: '0.875rem',
    sm: '1rem',
    md: '1.125rem',
    lg: '1.125rem',
    xl: '1.5rem',
    hero: 'clamp(2rem, 5vw, 3rem)',
  },
  space: [0, 4, 8, 12, 16, 24, 32, 48, 64],
  radii: {
    sm: 4,
    md: 8,
    lg: 16,
    pill: 999,
  },
};
